export default "__VITE_ASSET__BBODQYFm__";